var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCycleNades(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 8.467 8.467",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fff"
    },
    d: "M6.96.101c-.111-.002-.233.033-.366.185l-.04.028-.007 1.003c-.183.035-.303.154-.312.28l-.015 2.41c.343.09.711.085 1.1.007l-.025-2.41c-.005-.165-.142-.251-.303-.284l.005-.79c.293.513.398.934.44 1.545l.148.03.002-.24.065.172.135-.005C7.77 1.632 7.495.11 6.96.1ZM.85 1.407a.433.433 0 0 0-.095.57l-.47.383-.07.115.107.17.164-.101.095.144.12.19c-.157.139-.283.287-.32.472a.91.91 0 0 0 .17.753c.338.424 1.017.444 1.516.045.5-.4.63-1.067.292-1.49a.911.911 0 0 0-.699-.33c-.185-.006-.34.07-.497.181l-.126-.08-.117-.106.133-.14 1.035.042.803.87.15-.122-.877-.935-.692-.042a.433.433 0 0 0-.015-.521.433.433 0 0 0-.608-.068Zm.1.125a.272.272 0 0 1 .382.043.272.272 0 0 1-.043.382.272.272 0 0 1-.038.026L.96 1.965a.272.272 0 0 1-.052-.05.272.272 0 0 1 .042-.383zM3.116 7.086a.356.356 0 0 0 .279.364l-.007.005-.018.43.034.071.237.011.034-.05.39.018-.01.125.045.163.385.022.1-.154 1.247.06.087.162.375.01.09-.147.028-.67-.062-.16-.384-.02-.102.154-1.247-.06-.085-.163-.359-.017-.083.155-.004.092-.39-.018-.04-.036.472-.33 1.535.07.004-.154-1.583-.057-.26.184a.356.356 0 0 0 .002-.027.356.356 0 0 0-.338-.372.356.356 0 0 0-.372.339Zm.118.006a.237.237 0 0 1 .248-.226.237.237 0 0 1 .226.248.237.237 0 0 1-.248.226.237.237 0 0 1-.226-.248Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fff"
    },
    d: "m4.122 4.99-1.144-.054.475-2.445-.768-.297 2.907-1.092.184 2.31-.845-.49Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fff"
    },
    d: "M4.544 4.599 5 3.549l2.12 1.307.549-.614-.005 3.105-2.225-.644.756-.616Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fff"
    },
    d: "m4.854 5.209.39 1.076-2.439.504.023.823-2.129-2.26 2.06-1.06-.126.967Z"
  }));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCycleNades);
export default __webpack_public_path__ + "static/media/cycle-nades.6aa8bb8e64702733c1bffa6ae9da2b74.svg";
export { ForwardRef as ReactComponent };